export enum CompanyKind {
  ADMIN = 0,
  CLINIC = 1,
  LAB = 2,
}

export enum CompanyPlanKind {
  NO_PLAN = 0,
  STARTER = 1,
  CONNECTED_STARTER = 3,
  ESSENTIAL = 10,
  STANDARD = 20,
  PREMIUM = 30,
  BASIC = 60,
  NEW_CREDIT = 70,
}

// TODO class 하나 만들자 ..
export const CompanyPlanKindLabel: Record<CompanyPlanKind, string> = {
  [CompanyPlanKind.NO_PLAN]: "NoPlan",
  [CompanyPlanKind.STARTER]: "Starter",
  [CompanyPlanKind.CONNECTED_STARTER]: "커넥티드스타터",
  [CompanyPlanKind.ESSENTIAL]: "Essential",
  [CompanyPlanKind.STANDARD]: "Standard",
  [CompanyPlanKind.PREMIUM]: "Premium",
  [CompanyPlanKind.BASIC]: "Basic",
  [CompanyPlanKind.NEW_CREDIT]: "New크레딧플랜",
};

export enum CompanyPlanState {
  ACTIVE = 0,
  NORMAL = 50,
}

export enum CompanyPaymentKind {
  CARD = 1,
  CREDIT = 2,
}

export enum CompanyState {
  NORMAL = 0,
  DELETED = 100,
}

export enum CompanyWithdrawalKind {
  REQUESTED_WITHDRAWAL = 0,
  SIGN_UP = 10,
  NORMAL = 50,
  PENDING_APPROVAL = 80,
  SUSPENDED = 90,
  WITHDRAWN = 100,
}

export enum CompanyCustomerStatus {
  SIGN_UP = 10,
  INSTALLATION_PENDING = 20,
  NORMAL = 50,
  WITHDRAWN = 100,
}

export interface PlanConfig {
  id: number;
  name: string;
  state: CompanyPlanState;
  description?: string;
  contractMonth?: number;
  monthAmount?: number;
  commitmentAmount?: number;
  pointChargeRate?: number;
  pointUseRate?: number;
  useCredit: boolean;
  turn: number;
}

export const PlanConfigs: Record<CompanyPlanKind, PlanConfig> = {
  [CompanyPlanKind.NEW_CREDIT]: {
    id: 70,
    name: "New크레딧플랜",
    state: CompanyPlanState.ACTIVE,
    description: "전체 결제 금액에 대해 크레딧 결제",
    useCredit: true,
    turn: 0,
  },
  [CompanyPlanKind.BASIC]: {
    id: 60,
    name: "Basic",
    state: CompanyPlanState.ACTIVE,
    useCredit: true,
    turn: 1,
  },
  [CompanyPlanKind.NO_PLAN]: {
    id: 0,
    name: "No Plan",
    state: CompanyPlanState.NORMAL,
    description: "최초가입 상태",
    useCredit: false,
    turn: 0,
  },
  [CompanyPlanKind.PREMIUM]: {
    id: 30,
    name: "Premium",
    state: CompanyPlanState.NORMAL,
    description: "스캐너 임대, 교육 및 저스트스캔 사용(2023년용)",
    contractMonth: 3,
    commitmentAmount: 1000000000000,
    pointUseRate: 20,
    useCredit: false,
    turn: 1,
  },
  [CompanyPlanKind.STANDARD]: {
    id: 20,
    name: "Standard",
    state: CompanyPlanState.NORMAL,
    description: "교육 및 저스트스캔 사용(2023년용)",
    contractMonth: 3,
    monthAmount: 1000000,
    commitmentAmount: 3000000,
    pointChargeRate: 10,
    pointUseRate: 20,
    useCredit: false,
    turn: 2,
  },
  [CompanyPlanKind.ESSENTIAL]: {
    id: 10,
    name: "Essential",
    state: CompanyPlanState.NORMAL,
    description: "저스트스캔 플랫폼만 사용",
    pointChargeRate: 10,
    pointUseRate: 20,
    useCredit: false,
    turn: 3,
  },
  [CompanyPlanKind.STARTER]: {
    id: 1,
    name: "스타터",
    state: CompanyPlanState.NORMAL,
    description: "3개월, 스캐너대여, 200만원",
    contractMonth: 3,
    commitmentAmount: 2000000,
    pointUseRate: 20,
    useCredit: false,
    turn: 4,
  },
  [CompanyPlanKind.CONNECTED_STARTER]: {
    id: 3,
    name: "커넥티드스타터",
    state: CompanyPlanState.NORMAL,
    description: "3개월, 스캐너비대여, 무료",
    contractMonth: 3,
    commitmentAmount: 0,
    pointUseRate: 20,
    useCredit: false,
    turn: 4,
  },
};

export const CompanyWithdrawalKindLabel: Record<CompanyWithdrawalKind, string> =
  {
    [CompanyWithdrawalKind.REQUESTED_WITHDRAWAL]: "탈퇴 요청",
    [CompanyWithdrawalKind.SIGN_UP]: "회원 가입",
    [CompanyWithdrawalKind.NORMAL]: "정상",
    [CompanyWithdrawalKind.PENDING_APPROVAL]: "승인 대기",
    [CompanyWithdrawalKind.SUSPENDED]: "이용 정지",
    [CompanyWithdrawalKind.WITHDRAWN]: "탈퇴",
  };

export const TEST_CLINIC_IDS = [
  30, 31, 34, 36, 52, 59, 66, 67, 73, 78, 111, 115, 122, 131, 135, 168, 197,
  207, 218, 226, 228, 229, 272, 273, 220, 248, 462,
];

// 시연용 계정 등 실제 주문처럼 취급하되 목록에서 배지로 구분 표시할 치과
export const SPECIAL_MANAGEMENT_CLINIC_IDS = [842];

export const CLINICS_TO_EXCLUDE = [
  { id: 273, name: "secutest" },
  { id: 32, name: "test" },
  { id: 379, name: "test lab" },
  { id: 387, name: "test lab delete me" },
  { id: 394, name: "맑은치과" },
  { id: 393, name: "복현치과" },
  { id: 220, name: "에이블 테스트 치과 (삭제)" },
  { id: 395, name: "원치과" },
  { id: 396, name: "이종석 치과 의원" },
  { id: 392, name: "좋은서울미래치과의원" },
  { id: 397, name: "좋은서울미래치과의원" },
  { id: 215, name: "테스트_CCC치과" },
  { id: 218, name: "테스트_DDD 치과" },
  { id: 223, name: "테스트_eee치과" },
  { id: 226, name: "테스트_fff 치과" },
  { id: 248, name: "테스트_GGG" },
  { id: 228, name: "테스트_GGG 병원" },
  { id: 168, name: "테스트_just clinic" },
  { id: 50, name: "테스트_MEDIT Clinic" },
  { id: 78, name: "테스트_test치과" },
  { id: 30, name: "테스트_개발팀치과" },
  { id: 207, name: "테스트_개발팀치과2" },
  { id: 176, name: "테스트_글라우드" },
  { id: 36, name: "테스트_글라우드 교육팀" },
  { id: 197, name: "테스트_김재익테스트" },
  { id: 193, name: "테스트_대구 저스트익스프레스치과" },
  { id: 137, name: "테스트_덴티움" },
  { id: 140, name: "테스트_덴티움" },
  { id: 159, name: "테스트_덴티움치과" },
  { id: 135, name: "테스트_마곡영업사무실" },
  { id: 162, name: "테스트_묵치과6" },
  { id: 270, name: "테스트_병원" },
  { id: 265, name: "테스트_보안점검" },
  { id: 266, name: "테스트_보안점검" },
  { id: 267, name: "테스트_보안점검" },
  { id: 268, name: "테스트_보안점검" },
  { id: 210, name: "테스트_서민영치과" },
  { id: 170, name: "테스트_서울강서 아이피랩" },
  { id: 229, name: "테스트_송파 RRR 치과" },
  { id: 173, name: "테스트_송파사무실" },
  { id: 66, name: "테스트_시덱스" },
  { id: 98, name: "테스트_씨케이디엔씨" },
  { id: 52, name: "테스트_여정현 치과" },
  { id: 188, name: "테스트_운영가입기본셋팅" },
  { id: 149, name: "테스트_운영테스트1" },
  { id: 59, name: "테스트_익치과" },
  { id: 158, name: "테스트_임시가입테스트" },
  { id: 73, name: "테스트_재익테스트" },
  { id: 175, name: "테스트_저스트병원" },
  { id: 111, name: "테스트_저스트스캔" },
  { id: 115, name: "테스트_저스트치과" },
  { id: 182, name: "테스트_체험치과" },
  { id: 181, name: "테스트_체험판테스트" },
  { id: 88, name: "테스트_치과" },
  { id: 51, name: "테스트_카이특허법인" },
  { id: 211, name: "테스트_크레딧치과" },
  { id: 167, name: "테스트_테스트6" },
  { id: 131, name: "테스트_테스트병원" },
  { id: 245, name: "테스트_테스트병원" },
  { id: 122, name: "테스트_테스트용가입치과" },
  { id: 31, name: "테스트_테스트치과" },
  { id: 157, name: "테스트_호균테스트" },
  { id: 67, name: "테스트_황동현 테스트 치과" },
  { id: 252, name: "테스트계정" },
  { id: 239, name: "테스트랩" },
  { id: 180, name: "테스트병원1" },
];

export enum OnboardingCurrentStep {
  DEFAULT = 0,
  BASIC_INFO = 1,
  BUSINESS_INFO = 2,
  INSTALLATION_INFO = 3,
  COMPLETED = 4,
}

// 가입 경로 옵션
/** 행사 혜택 판정에 쓰는 GAMEX 2026 전용 가입 경로 식별값. */
export const GAMEX_2026_SIGNUP_PATH = "GAMEX_2026" as const;

export const SIGNUP_PATHS = {
  "지인 추천": "저스트스캔 사용 치과의사 등의 추천",
  SNS: "페이스북, 유튜브 등의 SNS 광고",
  "전시/세미나": "SIDEX /GAMEX 등의 전시회, 세미나",
  언론: "치과신문, 치의신보 등의 기사/광고",
  "인터넷 검색": "네이버, 구글 등 검색",
  웨비나: "언론사 등 주관 웨비나",
  기타: "직접 입력 (영업사원)",
} as const;
